import { Box } from "@mui/system";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function SortMenuLabel({ children }: Props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {children}
    </Box>
  );
};
